export const isAssetImport = (entity) => ['assets', 'assetsGeneral'].includes(entity);

export const isGeneralImport = (entity) => ['assetsGeneral', 'vulnsGeneral'].includes(entity);

export const buildUploadParams = ({
  entity,
  file,
  resolveHost,
  minSeverity,
  maxSeverity
}) => {
  const params = [
    { name: 'file', value: file },
    { name: 'resolve_hostname', value: resolveHost }
  ];

  if (!isAssetImport(entity)) {
    params.push(
      { name: 'min_severity', value: minSeverity.severity },
      { name: 'max_severity', value: maxSeverity.severity }
    );
  }

  return params;
};
